/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum TrainingFrequencyType {
    Daily = 'DAILY',
    Weekly = 'WEEKLY',
    Biweekly = 'BIWEEKLY',
    Custom = 'CUSTOM'
}


export function instanceOfTrainingFrequencyType(value: any): boolean {
    for (const key in TrainingFrequencyType) {
        if (Object.prototype.hasOwnProperty.call(TrainingFrequencyType, key)) {
            if (TrainingFrequencyType[key as keyof typeof TrainingFrequencyType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TrainingFrequencyTypeFromJSON(json: any): TrainingFrequencyType {
    return TrainingFrequencyTypeFromJSONTyped(json, false);
}

export function TrainingFrequencyTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrainingFrequencyType {
    return json as TrainingFrequencyType;
}

export function TrainingFrequencyTypeToJSON(value?: TrainingFrequencyType | null): any {
    return value as any;
}

export function TrainingFrequencyTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): TrainingFrequencyType {
    return value as TrainingFrequencyType;
}

